export const PROCESSING_SPEED = 'PROCESSING_SPEED';
export const MARGIN = 'MARGIN';
export const POPULARITY = 'POPULARITY';
export const EVOLUTIVE = 'EVOLUTIVE';
